$(window).scroll(function () {
  if ($(this).scrollTop() > 75) {
    $(".site-header").addClass("fixed-header");
    $("body").addClass("fixed");
  } else {
    $(".site-header").removeClass("fixed-header");
    $("body").removeClass("fixed");
  }
});

$(".showSearch").click(function () {
  $(".searchInput").toggle("fast");
});

// select the target node
let target = document.querySelector(".template-cart .cart-note");
let target2 = document.querySelector(".template-cart .cart__shipping");

// create an observer instance
let observer = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    if (mutation.type == "attributes") {
      if (window.matchMedia("(max-width: 750px)").matches) {
        // If media query matches
        target.style.display = "none";
      }
    }
  });
});

// create an observer instance
let observer2 = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    if (mutation.type == "attributes") {
      target2.style.display = "block";
      target2.style.visibility = "visible";
    }
  });
});

// configuration of the observer:
let config = { attributes: true, childList: true, characterData: true };

if (target) {
  observer.observe(target, config);
}
if (target2) {
  observer2.observe(target2, config);
}

$(".open-shop").hover(function () {
  $("header").toggleClass("headerBottomShop");
  $(".discover-menu").addClass("hide");
  $(".discover-marker").addClass("hide");
  $(".shop-marker").toggleClass("hide");
  $(".shop-menu").toggleClass("hide");
});

$(".open-discover").hover(function () {
  $("header").toggleClass("headerBottomDiscover");
  $(".shop-menu").addClass("hide");
  $(".shop-marker").addClass("hide");
  $(".discover-marker").toggleClass("hide");
  $(".discover-menu").toggleClass("hide");
});

$(".mobile-menu-links .has-dropdown").click(function () {
  $(this).find("ul").toggleClass("active");
  $(this).find(".first-link span").toggleClass("rotated");
});

$('#play-video').on('click', function() {
  $(this).find('div.custom-play-btn__image').hide();
  $("#video")[0].src += "&autoplay=1";
});

if ($("#vimeo-id").length > 0) {
  $.getJSON(
    "https://www.vimeo.com/api/v2/video/244809918.json?callback=?",
    { format: "json" },
    function (data) {
      $("#vimeo-id").attr("src", data[0].thumbnail_large);
    }
  );

  $("#vimeo-id").on("click", function () {
    $(this).fadeOut();
    $(".play-button").fadeOut();
    let iframe = $("#vimeo-video")[0];
    let player = $f(iframe);
    player.api("play");
  });
}

// Custom Accordion
$(".accordion .accordion__block .heading").on("click", function () {
  var accordion_block = $(this).parent(".accordion__block");
  accordion_block.toggleClass("open");
  accordion_block.find(".hidden-content").stop().slideToggle();
});

// Check if a hashtag exists both in the url and on the page...
if (window.location.hash && $(window.location.hash).length > 0) {
  // If accordion open on page load...
  var accordion = $(window.location.hash);
  if (accordion.hasClass("accordion__block")) {
    accordion.addClass("open");
    accordion.find(".hidden-content").stop().slideToggle();
  }
}

// Update Default Address (Shortcut)
$(".customers .address a.make-default-address").on("click", function (e) {
  e.preventDefault();
  var address_id = $(this).data("id");
  var address_form = $("form#address_form_" + address_id);
  address_form
    .find("input#address_default_address_" + address_id)
    .prop("checked", true);
  address_form.submit();
});

// Klarna Widget (Popup)
$("span.klarna-custom-widget a").on("click", function (e) {
  e.preventDefault();
  Fancybox.show(
    [
      {
        src: "#klarna-popup",
        type: "inline",
        closeButton: "inside",
      },
    ],
    {
      template: {
        closeButton:
          '<svg version="1.1" id="close-btn" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 8 8" xml:space="preserve"><path d="M7.4 7.4L.6.6m6.8 0L.6 7.4" fill="none" stroke="#000000"/></svg>',
      },
    }
  );
});

// Country Selector (Popup)
$("div.selected-country").on("click", function () {
  Fancybox.show(
    [
      {
        src: "#country-selector",
        type: "inline",
        closeButton: "inside",
      },
    ],
    {
      template: {
        closeButton:
          '<svg version="1.1" id="close-btn" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 8 8" xml:space="preserve"><path d="M7.4 7.4L.6.6m6.8 0L.6 7.4" fill="none" stroke="#000000"/></svg>',
      },
    }
  );
});

// Country Selector
$("form.shopify-localization-form select#shopify-localization").on(
  "change",
  function () {
    var localization_form = $(this).parent("form.shopify-localization-form");
    localization_form.find("input.country-code").val($(this).val());
    localization_form.submit();
  }
);

// Custom Product Slider (Dots)
$("ul.carousel-dots li.carousel-dots__dot").on("click", function () {
  $("ul.carousel-dots li").removeClass("active");
  $(this).addClass("active");
});

// Cart - Mini Cart (Hack)
$("a.site-header__cart").on("click", function (e) {
  if (
    $("body").hasClass("template-search") ||
    $("body").hasClass("template-collection")
  ) {
    e.preventDefault();
    var cart_url = $(this).attr("href");
    window.location.href = cart_url;
  }
});

// Collection Read More
$(".collection-description .collection-description__inner a.rm-btn").on(
  "click",
  function () {
    var rm_btn = $(this).text();
    $(this).text(rm_btn == "Read More" ? "Read Less" : "Read More");
    $(this).parent().prev(".rm-inner").slideToggle();
  }
);

// Logout Link
$("span.logout-link").on("click", function () {
  var logout_url = $(this).data("url");
  $.ajax({
    type: "POST",
    dataType: "json",
    url: "/cart/clear.js",
    success: function () {
      window.location.href = logout_url;
    },
  });
});

// function update_menu_state(element, action) {
//   $('.open-shop--dropdown li.image-link.has-image').each(function() {
//     if ( action == 'add' ) {
//       if ( $(this).data('id') !== element.data('id') ) {
//         $(this).addClass('hover-active');
//       }
//     } else {
//       if ( $(this).data('id') !== element.data('id') ) {
//         $(this).removeClass('hover-active');
//       }
//     }
//   });
// }

// $('.no-touchevents li.image-link.has-image').hover(
//   function () {
//     update_menu_state($(this), 'add');
//   },
//   function () {
//     update_menu_state($(this), 'remove');
//   }
// );

/*
============
Mobile Menu
============
*/

$(document).ready(function () {
  $("header.site-header a.mobile-menu-btn").on("click", function (e) {
    e.preventDefault();
    $("body").addClass("mobile-menu-active");
  });

  $(".sidenav a.closebtn").on("click", function (e) {
    e.preventDefault();
    $("body").removeClass("mobile-menu-active");
  });

  // Hide the mobile menu if expanding from mobile to desktop...
  function mobile_menu() {
    if (window.innerWidth >= 767) {
      $("body").removeClass("mobile-menu-active");
    }
  }
  window.addEventListener("resize", mobile_menu);
  window.addEventListener("orientationchange", mobile_menu);

  // Get javascript cookies...
  function get_cookie(name) {
    var dc = document.cookie;
    var prefix = name + "=";
    var begin = dc.indexOf("; " + prefix);
    if (begin == -1) {
      begin = dc.indexOf(prefix);
      if (begin != 0) return null;
    } else {
      begin += 2;
      var end = document.cookie.indexOf(";", begin);
      if (end == -1) {
        end = dc.length;
      }
    }
    return decodeURI(dc.substring(begin + prefix.length, end));
  }

  // Get 'GlobalE_Data' cookie...
  // var globale_cookie = get_cookie('GlobalE_Data');
  // if ( globale_cookie !== null ) {
  //     var globale_data = JSON.parse(decodeURIComponent(document.cookie.match('(^|;)\\s*GlobalE_Data\\s*=\\s*([^;]+)')?.pop())) || { currencyCode: 'GBP', countryISO: 'GB'};
  //     var ge_currency = globale_data.currencyCode;
  //     $('body').removeClass('standard-popup');
  //     if ( ge_currency == 'USD' ) {
  //         $('body').addClass('usd-popup');
  //     } else {
  //         $('body').addClass('standard-popup');
  //     }
  // } else {
  //     $('body').addClass('standard-popup');
  // }
});

// Lifestyle Image Slider
// $(window).on('load resize orientationchange', function() {

//     // Set lifestyle image slider...
//     var lifestyle_images = $('.js-lifestyle-slider--lrg');

//     // If more than 767px...
//     if ( $(window).width() > 767 ) {

//       lifestyle_images.slick({
//         infinite: true,
//         arrows: true,
//         dots: false,
//         slidesToShow: 3,
//         slidesToScroll: 3
//       });

//     } else {

//       lifestyle_images.slick({
//         infinite: true,
//         arrows: true,
//         dots: true,
//         slidesToShow: 1,
//         slidesToScroll: 1
//       });

//     }

// });

/*
==============
Smooth Scroll
==============
*/

// $('a[href*="#"]')
//     // Remove links that don't actually link to anything
//     .not('[href="#"]')
//     .not('[href="#0"]')
//     .click(function(event) {
//         // On-page links
//         if ( location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname ) {
//             // Figure out element to scroll to
//             var target = $(this.hash);
//             target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
//             // Does a scroll target exist?
//             if (target.length) {
//                 // Only prevent default if animation is actually gonna happen
//                 event.preventDefault();
//                 $('html, body').animate({
//                 scrollTop: target.offset().top
//             }, 1000, function() {
//                 // Callback after animation
//                 // Must change focus!
//                 var $target = $(target);
//                 $target.focus();
//                 if ($target.is(":focus")) { // Checking if the target was focused
//                     return false;
//                 } else {
//                     $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
//                     $target.focus(); // Set focus again
//                 };
//             });
//         }
//     }
// });

$(function () {
  // Product Description Accordion
  $(".product-single__description h5").nextUntil("h5").hide();
  $(".product-single__description h5").click(function () {
    $(this).toggleClass("opened");
    $(this).nextUntil("h5").slideToggle();
  });

  $(".js-lifestyle-slider--lrg").slick({
    infinite: true,
    arrows: true,
    dots: false,
    slidesToShow: 3,
    slidesToScroll: 3,
  });

  $(".js-lifestyle-slider--sml").slick({
    infinite: true,
    arrows: true,
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  });

  // $('.product-image-zoom').zoom({
  //   magnify: 1
  // });
});

$(document).ready(function () {
  if (window.matchMedia("(max-width: 767px)").matches) {
    $(".hide-video").remove();
    // $(".vp-placeholder-fadeout").remove();

    $(".product-image-zoom").on("click", function () {
      $(".product-image-zoom").trigger("zoom.destroy");
    });
  } else {
    $(".product-image-zoom").zoom({
      magnify: 1,
    });
  }
});

// $(document).ready(function () {
//   $(".collection-select").selectric({
//     maxHeight: 350,
//   });
// });

// $(document).ready(function() {
//   $("#myCarousel").swiperight(function() {
//      $(this).carousel('prev');
//    });
//   $("#myCarousel").swipeleft(function() {
//      $(this).carousel('next');
//   });
// });

// $(document).on('click', 'a[href^="#"]', function (event) {
//   event.preventDefault();

//   $('html, body').animate({
//       scrollTop: $($.attr(this, 'href')).offset().top
//   }, 1000);
// });

/**
 * Collection Filters
 */

$(document).ready(function () {

  // Toggle filters...
  $('div.filter-group span.filter-group__title').on('click', function (e) {

    // Prevent this click from reaching the body handler
    e.stopPropagation();

    var filterGroup = $(this).parents('div.filter-group');

    // Close all other filter groups
    $('div.filter-group').not(filterGroup).removeClass('open');

    // Toggle the clicked filter group
    filterGroup.toggleClass('open');
  });

  // Prevent closing when clicking inside the filter group
  $('div.filter-group').on('click', function (e) {
    e.stopPropagation();
  });

  // Remove filters when clicking outside
  $('body').on('click', function () {
    $('div.filter-group').removeClass('open');
  });

  // Get filter selection when a checkbox is toggled
  $('div.filter-group input[type="checkbox"]').on('change', function () {
    var filterGroup = $(this).closest('div.filter-group');
    var field = filterGroup.attr('class').split(' ').find(cls => cls !== 'filter-group');
    if (field) {
      get_filter_selection(field);
    }
    collection_filter();
  });

  // Get filter selection function
  function get_filter_selection(field) {
    var checked_values = $(`div.filter-group.${field} div.filter-group__options input[type="checkbox"]:checked`);
    var joined_values = checked_values.map(function () {
      return $(this).val();
    }).get().join(',');
    $(`input#filter-${field}`).val(checked_values.length > 0 ? joined_values : '');
  }

  // Read url parameters...
  function get_url_parameter(name) {
      name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
      var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
      results = regex.exec(location.search);
      return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
  }

  // Get selected availability...
  function get_selected_availability() {
    var availability = get_url_parameter('availability');
    if ( availability ) {
      var availability_array = availability.split(' ');
      $.each(availability_array, function(index, value) {
        $('div.filter-group.availability div.option input[value="' + value + '"]').attr('checked', true);
      });      
      get_filter_selection('availability');
    }
    collection_filter();
  }

  // Get filtered collection state...
  function get_filtered_state() {
    var url_array = window.location.pathname.split('/');
    // Check if collection page...
    if ( $.inArray('collections', url_array) !== -1 ) {
      // Get tags from the url...
      if ( url_array.length >= 3 ) {
        var tags = window.location.pathname.split('/').pop();
        var tags_array = tags.split('+').filter(Boolean);
        if ( tags_array.length > 0 ) {
          $.each(tags_array, function(index, value) {
            var tag = value.toLowerCase().replace(/ /g, '-');
            $('div.option input[value="' + tag + '"]').attr('checked', true);
            get_filter_selection('colours');
            get_filter_selection('materials');
            get_filter_selection('use');
          });
        }
      }
      // Get availability...
      get_selected_availability();
    }
  }
  get_filtered_state();

  // Show/Hide Filters...
  function get_available_filters() {
    var tag_element = $('#tag-data');
    if ( tag_element.length > 0 ) {
      var tag_data = JSON.parse($('#tag-data').html());
      if ( tag_data.tags.length > 0 ) {
        $.each(tag_data.tags, function(index, value) {
          var input = $('div.filter-group div.option input[value="' + value.tag + '"]');
          if ( !input.parents('div.filter-group').hasClass('availability') ) {
            input.parent('div.option').find('span.count').text('(' + value.count + ')');
          }
          input.parent('div.option').attr('data-show', 'true');
        });
      }
    }
  }
  get_available_filters();

  // Get 'in-stock' and 'pre-order' counts...
  function get_available_counts() {
    var in_stock_count = 0;
    var pre_order_count = 0;
    $('div.filter-results__products div.collection-filter-product').each(function(index) {
      if ( $(this).attr('data-in-stock') == 'true' && $(this).attr('data-pre-order') == 'false' ) {
        ++in_stock_count;
      }
      if ( $(this).attr('data-pre-order') == 'true' ) {
        ++pre_order_count;
      }
    });
    $('input#in-stock').parent('div.option').find('span.count').text('(' + in_stock_count + ')');
    $('input#pre-order').parent('div.option').find('span.count').text('(' + pre_order_count + ')');
  }

  // Custom function to help find common elements in two arrays (OR based query)...
  function find_common_elements(array1, array2) {
    // Convert all elements in both arrays to lowercase...
    const lowerArray1 = array1.map(element => element.toString().toLowerCase());
    const lowerArray2 = array2.map(element => element.toString().toLowerCase());
    // Loop over lowerArray1...
    for (let i = 0; i < lowerArray1.length; i++) {
      // Loop over lowerArray2...
      for (let j = 0; j < lowerArray2.length; j++) {
        // Compare every element from both of the arrays...
        if (lowerArray1[i] === lowerArray2[j]) {
          // Return true if common element is found...
          return true;
        }
      }
    }
    // Return false if no common element exists...
    return false;
  }

  // Custom function to help find all matching elements in two arrays (AND based query)...
  function find_matching_elements(array1, array2) {
    // Convert all elements in both arrays to lowercase...
    const lowerArray1 = array1.map(element => element.toString().toLowerCase());
    const lowerArray2 = array2.map(element => element.toString().toLowerCase());
    // Loop over arrays...
    var array1_length = lowerArray1.length;
    var array2_length = lowerArray2.length;
    if (array1_length <= array2_length) {
      for (var i = 0; i < array1_length; i++) {
        if (!(lowerArray2.indexOf(lowerArray1[i]) >= 0)) {
          return false;
        }
      }
    } else {
      return false;
    }
    return true;
  }

  // Collection filter...
  function collection_filter() {
  
  	// Get sort by and filter tags...
  	var sort_by = $('select#sort-by option:selected').val();
    var colour_filters = $('input#filter-colours').val();
    var material_filters = $('input#filter-materials').val();
    var use_filters = $('input#filter-use').val();
    var availability = $('input#filter-availability').val();

    // Get tags and filter urls...
    var tags = $('div.filter-results__results input#tags').val();
  	var filter_url = $('div.filter-results__results input#filter-url').val();
    var collection_url = $('div.filter-results__results input#collection-url').val();

  	// Set the query string...
  	var query_string = '';
  	if ( sort_by !== 'manual' ) {
      query_string = '?sort_by=' + sort_by + '&view=filter';
  	} else {
      query_string = '?view=filter';
    }

    // Set the query string url...
  	var query_string_url = '';
  	if ( sort_by !== 'manual' ) {
      query_string_url = '?sort_by=' + sort_by;
  	}
    if ( availability !== '' ) {
      if ( query_string_url == '' ) {
        query_string_url = '?availability=' + availability.split(',').join('+');
      } else {
        query_string_url += '&availability=' + availability.split(',').join('+');
      }
    }

    // Create an array to store the matches product ids...
    var product_ids = [];
    
    // Run AJAX request...
    $.ajax({
      url: collection_url + query_string,
      type: 'GET',
      beforeSend: function() {
        $('div.filter-results__products').empty();
        $('div.filter-results__results span.ajax-loader').remove();
        $('div.filter-results__results p.no-results').remove(); 
        $('div.filter-results__results').append('<span class="ajax-loader"></span>');
      },
      success: function(data) {

        // Get all tags...
        var tags = [colour_filters, material_filters, use_filters].filter(Boolean).join(',');

        // Convert 'tags' string to an array...
        var tags_array = ( tags.length > 0 ? tags.split(',') : false );

        // Convert 'availability' string to an array...
        var availability_array = ( availability.length > 0 ? availability.split(',') : false );

        // Set product count...
        var product_count = 0;

        // Get the response...
        var response = JSON.parse(data);
        if ( response.products ) {

          // Loop over all products...
          $.each(response.products, function(product, info) {

            // If tags...
            if ( tags_array !== false ) {

              // Check for matching elements (AND based query)...
              var tag_result = find_matching_elements(tags_array, info.tags);

              // Check for common tags (OR based query)...
              //var tag_result = find_common_elements(tags_array, info.tags);
  
              // Check if tag result is found...
              if ( tag_result == true ) {
  
                // If availability filters...
                if ( availability_array !== false ) {

                  // Check for matching elements (AND based query)...
                  var availability_result = find_matching_elements(availability_array, info.availability);

                  // Check for common tags (OR based query)...
                  //var availability_result = find_common_elements(availability_array, info.availability);

                  // Check if availability match...
                  if ( availability_result == true ) {
                  
                    // Only return value if it doesn't already exist...
                    if ( !product_ids.includes(info.id) ) {
                      product_ids.push(info.id);
                    }
                  }
                  
                } else {

                  // Only return value if it doesn't already exist...
                  if ( !product_ids.includes(info.id) ) {
                    product_ids.push(info.id);
                  }
                  
                }
  
              }

            } else {

              // If availability filters...
              if ( availability_array !== false ) {

                // Check for matching elements (AND based query)...
                var availability_result = find_matching_elements(availability_array, info.availability);

                // Check for common tags (OR based query)...
                //var availability_result = find_common_elements(availability_array, info.availability);

                // Check if availability match...
                if ( availability_result == true ) {
                
                  // Only return value if it doesn't already exist...
                  if ( !product_ids.includes(info.id) ) {
                    product_ids.push(info.id);
                  }
                }
                
              } else {

                // Only return value if it doesn't already exist...
                if ( !product_ids.includes(info.id) ) {
                  product_ids.push(info.id);
                }
                
              }
              
            }

            // Output products...
            if ( $.inArray(info.id, product_ids) !== -1 ) {
              product_count++;
              $('div.filter-results__products').append(info.data);
            }

          });

        }

        // If tags...
        if ( tags_array !== false ) {

          // Update filtered url...
          var url_tags = tags.toLowerCase().replace(/ /g, '-').split(',').join('+');
          $('div.filter-results__results input#filter-url').val(collection_url + '/' + url_tags);  
          if ( query_string_url !== '' ) {
            window.history.replaceState(null, null, collection_url + '/' + url_tags + query_string_url);
          } else {
            window.history.replaceState(null, null, collection_url + '/' + url_tags);
          }

        } else {

          // Update filtered url...
          $('div.filter-results__results input#filter-url').val(collection_url);
          if ( query_string_url !== '' ) {
            window.history.replaceState(null, null, collection_url + query_string_url);
          } else {
            window.history.replaceState(null, null, collection_url);
          }

        }

        // Update the results count...
        if ( parseInt(product_count) == 0 ) {
          $('div.filter-results__products').empty();
          $('div.filter-results__results').append('<p class="no-results">No results found</p>'); 
        }

        // Remove loader...
        $('div.filter-results__results span.ajax-loader').remove();
        
      },
      complete: function() {
        get_available_counts();
        init_image_slider();
      }
    });
  
  }
  
  // Filter the collection when the 'sortby' filter changes...
  $('select#sort-by').on('change', function() {
  	collection_filter();
  });

  $('.sort-by__title').on('click', function () {
    var sort_by_select = $('#sort-by');
    sort_by_select.trigger('focus').trigger('mousedown');
  });

  // Image slider...
  function init_image_slider() {
    var isMobile = window.innerWidth <= 600;
    var $sliders = $('.grid-view-item__slider');
    if ( !$sliders.length ) return;

    $sliders.each(function () {
      var $slider = $(this);
      var hasFlickity = !!$slider.data('flickity');

      if ( isMobile && !hasFlickity ) {

        $slider.flickity({
          cellAlign: 'center',
          contain: true,
          wrapAround: true,
          pageDots: true,
          prevNextButtons: false,
          autoPlay: false,
          imagesLoaded: true,
          dragThreshold: 15
        });

        // $slider.imagesLoaded().always(function () {
        //   var flkty = $slider.data('flickity');
        //   if (flkty) flkty.resize();
        // });

        $slider.on( 'staticClick.flickity', function(event, pointer, cellElement, cellIndex) {
          var link = $(this)
            .closest('.collection-filter-product')
            .find('a.grid-view-item__link')
            .get(0);
          if ( link ) {
            link.click();
          }
        });
        
      }

      if ( !isMobile && hasFlickity ) {
        $slider.flickity('destroy');
      }

      $slider.find('img').on('load', function () {
        var flkty = $slider.data('flickity');
        if ( flkty ) {
          flkty.resize();
        }
      });

    });
  }
  init_image_slider();

  // Debounced resize listener...
  var resizeTimeout;
  $(window).on('resize', function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function () {
      init_image_slider();
    }, 200);
  });

  // Desktop slider link...
  $(document).on('click', '.grid-view-item__slider', function() {
    if ( window.innerWidth < 600 ) return;
    var link = $(this)
      .closest('.collection-filter-product')
      .find('a.grid-view-item__link')
      .get(0);
    if ( link ) {
      link.click();
    }
  });

});

/**
 * bxSlider v4.2.1d
 * Copyright 2013-2017 Steven Wanderski
 * Written while drinking Belgian ales and listening to jazz
 * Licensed under MIT (http://opensource.org/licenses/MIT)
 */
!(function (t) {
  var e = {
    mode: "horizontal",
    slideSelector: "",
    infiniteLoop: !0,
    hideControlOnEnd: !1,
    speed: 500,
    easing: null,
    slideMargin: 0,
    startSlide: 0,
    randomStart: !1,
    captions: !1,
    ticker: !1,
    tickerHover: !1,
    adaptiveHeight: !1,
    adaptiveHeightSpeed: 500,
    video: !1,
    useCSS: !0,
    preloadImages: "visible",
    responsive: !0,
    slideZIndex: 50,
    wrapperClass: "bx-wrapper",
    touchEnabled: !0,
    swipeThreshold: 50,
    oneToOneTouch: !0,
    preventDefaultSwipeX: !0,
    preventDefaultSwipeY: !1,
    ariaLive: !0,
    ariaHidden: !0,
    keyboardEnabled: !1,
    pager: !0,
    pagerType: "full",
    pagerShortSeparator: " / ",
    pagerSelector: null,
    buildPager: null,
    pagerCustom: null,
    controls: !0,
    nextText: "Next",
    prevText: "Prev",
    nextSelector: null,
    prevSelector: null,
    autoControls: !1,
    startText: "Start",
    stopText: "Stop",
    autoControlsCombine: !1,
    autoControlsSelector: null,
    auto: !1,
    pause: 4e3,
    autoStart: !0,
    autoDirection: "next",
    stopAutoOnClick: !1,
    autoHover: !1,
    autoDelay: 0,
    autoSlideForOnePage: !1,
    minSlides: 1,
    maxSlides: 1,
    moveSlides: 0,
    slideWidth: 0,
    shrinkItems: !1,
    onSliderLoad: function () {
      return !0;
    },
    onSlideBefore: function () {
      return !0;
    },
    onSlideAfter: function () {
      return !0;
    },
    onSlideNext: function () {
      return !0;
    },
    onSlidePrev: function () {
      return !0;
    },
    onSliderResize: function () {
      return !0;
    },
    onAutoChange: function () {
      return !0;
    },
  };
  t.fn.bxSlider = function (n) {
    if (0 === this.length) return this;
    if (this.length > 1)
      return (
        this.each(function () {
          t(this).bxSlider(n);
        }),
        this
      );
    var s = {},
      o = this,
      r = t(window).width(),
      a = t(window).height();
    if (!t(o).data("bxSlider")) {
      var l = function () {
          t(o).data("bxSlider") ||
            ((s.settings = t.extend({}, e, n)),
            (s.settings.slideWidth = parseInt(s.settings.slideWidth)),
            (s.children = o.children(s.settings.slideSelector)),
            s.children.length < s.settings.minSlides &&
              (s.settings.minSlides = s.children.length),
            s.children.length < s.settings.maxSlides &&
              (s.settings.maxSlides = s.children.length),
            s.settings.randomStart &&
              (s.settings.startSlide = Math.floor(
                Math.random() * s.children.length
              )),
            (s.active = { index: s.settings.startSlide }),
            (s.carousel = s.settings.minSlides > 1 || s.settings.maxSlides > 1),
            s.carousel && (s.settings.preloadImages = "all"),
            (s.minThreshold =
              s.settings.minSlides * s.settings.slideWidth +
              (s.settings.minSlides - 1) * s.settings.slideMargin),
            (s.maxThreshold =
              s.settings.maxSlides * s.settings.slideWidth +
              (s.settings.maxSlides - 1) * s.settings.slideMargin),
            (s.working = !1),
            (s.controls = {}),
            (s.interval = null),
            (s.animProp = "vertical" === s.settings.mode ? "top" : "left"),
            (s.usingCSS =
              s.settings.useCSS &&
              "fade" !== s.settings.mode &&
              (function () {
                for (
                  var t = document.createElement("div"),
                    e = [
                      "WebkitPerspective",
                      "MozPerspective",
                      "OPerspective",
                      "msPerspective",
                    ],
                    i = 0;
                  i < e.length;
                  i++
                )
                  if (void 0 !== t.style[e[i]])
                    return (
                      (s.cssPrefix = e[i]
                        .replace("Perspective", "")
                        .toLowerCase()),
                      (s.animProp = "-" + s.cssPrefix + "-transform"),
                      !0
                    );
                return !1;
              })()),
            "vertical" === s.settings.mode &&
              (s.settings.maxSlides = s.settings.minSlides),
            o.data("origStyle", o.attr("style")),
            o.children(s.settings.slideSelector).each(function () {
              t(this).data("origStyle", t(this).attr("style"));
            }),
            d());
        },
        d = function () {
          var e = s.children.eq(s.settings.startSlide);
          o.wrap(
            '<div class="' +
              s.settings.wrapperClass +
              '"><div class="bx-viewport"></div></div>'
          ),
            (s.viewport = o.parent()),
            s.settings.ariaLive &&
              !s.settings.ticker &&
              s.viewport.attr("aria-live", "polite"),
            (s.loader = t('<div class="bx-loading" />')),
            s.viewport.prepend(s.loader),
            o.css({
              width:
                "horizontal" === s.settings.mode
                  ? 1e3 * s.children.length + 215 + "%"
                  : "auto",
              position: "relative",
            }),
            s.usingCSS && s.settings.easing
              ? o.css(
                  "-" + s.cssPrefix + "-transition-timing-function",
                  s.settings.easing
                )
              : s.settings.easing || (s.settings.easing = "swing"),
            s.viewport.css({
              width: "100%",
              overflow: "hidden",
              position: "relative",
            }),
            s.viewport.parent().css({ maxWidth: u() }),
            s.children.css({
              float: "horizontal" === s.settings.mode ? "left" : "none",
              listStyle: "none",
              position: "relative",
            }),
            s.children.css("width", h()),
            "horizontal" === s.settings.mode &&
              s.settings.slideMargin > 0 &&
              s.children.css("marginRight", s.settings.slideMargin),
            "vertical" === s.settings.mode &&
              s.settings.slideMargin > 0 &&
              s.children.css("marginBottom", s.settings.slideMargin),
            "fade" === s.settings.mode &&
              (s.children.css({
                position: "absolute",
                zIndex: 0,
                display: "none",
              }),
              s.children
                .eq(s.settings.startSlide)
                .css({ zIndex: s.settings.slideZIndex, display: "block" })),
            (s.controls.el = t('<div class="bx-controls" />')),
            s.settings.captions && k(),
            (s.active.last = s.settings.startSlide === f() - 1),
            s.settings.video && o.fitVids(),
            "none" === s.settings.preloadImages
              ? (e = null)
              : ("all" === s.settings.preloadImages || s.settings.ticker) &&
                (e = s.children),
            s.settings.ticker
              ? (s.settings.pager = !1)
              : (s.settings.controls && C(),
                s.settings.auto && s.settings.autoControls && T(),
                s.settings.pager && b(),
                (s.settings.controls ||
                  s.settings.autoControls ||
                  s.settings.pager) &&
                  s.viewport.after(s.controls.el)),
            null === e ? g() : c(e, g);
        },
        c = function (e, i) {
          var n = e.find('img:not([src=""]), iframe').length,
            s = 0;
          if (0 === n) return void i();
          e.find('img:not([src=""]), iframe').each(function () {
            t(this)
              .one("load error", function () {
                ++s === n && i();
              })
              .each(function () {
                (this.complete || "" == this.src) && t(this).trigger("load");
              });
          });
        },
        g = function () {
          if (
            s.settings.infiniteLoop &&
            "fade" !== s.settings.mode &&
            !s.settings.ticker
          ) {
            var e =
                "vertical" === s.settings.mode
                  ? s.settings.minSlides
                  : s.settings.maxSlides,
              i = s.children.slice(0, e).clone(!0).addClass("bx-clone"),
              n = s.children.slice(-e).clone(!0).addClass("bx-clone");
            s.settings.ariaHidden &&
              (i.attr("aria-hidden", !0), n.attr("aria-hidden", !0)),
              o.append(i).prepend(n);
          }
          s.loader.remove(),
            m(),
            "vertical" === s.settings.mode && (s.settings.adaptiveHeight = !0),
            s.viewport.height(p()),
            o.redrawSlider(),
            s.settings.onSliderLoad.call(o, s.active.index),
            (s.initialized = !0),
            s.settings.responsive && t(window).on("resize", U),
            s.settings.auto &&
              s.settings.autoStart &&
              (f() > 1 || s.settings.autoSlideForOnePage) &&
              L(),
            s.settings.ticker && O(),
            s.settings.pager && z(s.settings.startSlide),
            s.settings.controls && q(),
            s.settings.touchEnabled && !s.settings.ticker && X(),
            s.settings.keyboardEnabled &&
              !s.settings.ticker &&
              t(document).keydown(B);
        },
        p = function () {
          var e = 0,
            n = t();
          if ("vertical" === s.settings.mode || s.settings.adaptiveHeight)
            if (s.carousel) {
              var o =
                1 === s.settings.moveSlides
                  ? s.active.index
                  : s.active.index * x();
              for (
                n = s.children.eq(o), i = 1;
                i <= s.settings.maxSlides - 1;
                i++
              )
                n =
                  o + i >= s.children.length
                    ? n.add(s.children.eq(i - 1))
                    : n.add(s.children.eq(o + i));
            } else n = s.children.eq(s.active.index);
          else n = s.children;
          return (
            "vertical" === s.settings.mode
              ? (n.each(function (i) {
                  e += t(this).outerHeight();
                }),
                s.settings.slideMargin > 0 &&
                  (e += s.settings.slideMargin * (s.settings.minSlides - 1)))
              : (e = Math.max.apply(
                  Math,
                  n
                    .map(function () {
                      return t(this).outerHeight(!1);
                    })
                    .get()
                )),
            "border-box" === s.viewport.css("box-sizing")
              ? (e +=
                  parseFloat(s.viewport.css("padding-top")) +
                  parseFloat(s.viewport.css("padding-bottom")) +
                  parseFloat(s.viewport.css("border-top-width")) +
                  parseFloat(s.viewport.css("border-bottom-width")))
              : "padding-box" === s.viewport.css("box-sizing") &&
                (e +=
                  parseFloat(s.viewport.css("padding-top")) +
                  parseFloat(s.viewport.css("padding-bottom"))),
            e
          );
        },
        u = function () {
          var t = "100%";
          return (
            s.settings.slideWidth > 0 &&
              (t =
                "horizontal" === s.settings.mode
                  ? s.settings.maxSlides * s.settings.slideWidth +
                    (s.settings.maxSlides - 1) * s.settings.slideMargin
                  : s.settings.slideWidth),
            t
          );
        },
        h = function () {
          var t = s.settings.slideWidth,
            e = s.viewport.width();
          if (
            0 === s.settings.slideWidth ||
            (s.settings.slideWidth > e && !s.carousel) ||
            "vertical" === s.settings.mode
          )
            t = e;
          else if (
            s.settings.maxSlides > 1 &&
            "horizontal" === s.settings.mode
          ) {
            if (e > s.maxThreshold) return t;
            e < s.minThreshold
              ? (t =
                  (e - s.settings.slideMargin * (s.settings.minSlides - 1)) /
                  s.settings.minSlides)
              : s.settings.shrinkItems &&
                (t = Math.floor(
                  (e + s.settings.slideMargin) /
                    Math.ceil(
                      (e + s.settings.slideMargin) /
                        (t + s.settings.slideMargin)
                    ) -
                    s.settings.slideMargin
                ));
          }
          return t;
        },
        v = function () {
          var t = 1,
            e = null;
          return (
            "horizontal" === s.settings.mode && s.settings.slideWidth > 0
              ? s.viewport.width() < s.minThreshold
                ? (t = s.settings.minSlides)
                : s.viewport.width() > s.maxThreshold
                ? (t = s.settings.maxSlides)
                : ((e = s.children.first().width() + s.settings.slideMargin),
                  (t =
                    Math.floor(
                      (s.viewport.width() + s.settings.slideMargin) / e
                    ) || 1))
              : "vertical" === s.settings.mode && (t = s.settings.minSlides),
            t
          );
        },
        f = function () {
          var t = 0,
            e = 0,
            i = 0;
          if (s.settings.moveSlides > 0) {
            if (!s.settings.infiniteLoop) {
              for (; e < s.children.length; )
                ++t,
                  (e = i + v()),
                  (i +=
                    s.settings.moveSlides <= v() ? s.settings.moveSlides : v());
              return i;
            }
            t = Math.ceil(s.children.length / x());
          } else t = Math.ceil(s.children.length / v());
          return t;
        },
        x = function () {
          return s.settings.moveSlides > 0 && s.settings.moveSlides <= v()
            ? s.settings.moveSlides
            : v();
        },
        m = function () {
          var t, e, i;
          s.children.length > s.settings.maxSlides &&
          s.active.last &&
          !s.settings.infiniteLoop
            ? "horizontal" === s.settings.mode
              ? ((e = s.children.last()),
                (t = e.position()),
                S(
                  -(t.left - (s.viewport.width() - e.outerWidth())),
                  "reset",
                  0
                ))
              : "vertical" === s.settings.mode &&
                ((i = s.children.length - s.settings.minSlides),
                (t = s.children.eq(i).position()),
                S(-t.top, "reset", 0))
            : ((t = s.children.eq(s.active.index * x()).position()),
              s.active.index === f() - 1 && (s.active.last = !0),
              void 0 !== t &&
                ("horizontal" === s.settings.mode
                  ? S(-t.left, "reset", 0)
                  : "vertical" === s.settings.mode && S(-t.top, "reset", 0)));
        },
        S = function (e, i, n, r) {
          var a, l;
          s.usingCSS
            ? ((l =
                "vertical" === s.settings.mode
                  ? "translate3d(0, " + e + "px, 0)"
                  : "translate3d(" + e + "px, 0, 0)"),
              o.css("-" + s.cssPrefix + "-transition-duration", n / 1e3 + "s"),
              "slide" === i
                ? (o.css(s.animProp, l),
                  0 !== n
                    ? o.on(
                        "transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd",
                        function (e) {
                          t(e.target).is(o) &&
                            (o.off(
                              "transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd"
                            ),
                            A());
                        }
                      )
                    : A())
                : "reset" === i
                ? o.css(s.animProp, l)
                : "ticker" === i &&
                  (o.css(
                    "-" + s.cssPrefix + "-transition-timing-function",
                    "linear"
                  ),
                  o.css(s.animProp, l),
                  0 !== n
                    ? o.on(
                        "transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd",
                        function (e) {
                          t(e.target).is(o) &&
                            (o.off(
                              "transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd"
                            ),
                            S(r.resetValue, "reset", 0),
                            F());
                        }
                      )
                    : (S(r.resetValue, "reset", 0), F())))
            : ((a = {}),
              (a[s.animProp] = e),
              "slide" === i
                ? o.animate(a, n, s.settings.easing, function () {
                    A();
                  })
                : "reset" === i
                ? o.css(s.animProp, e)
                : "ticker" === i &&
                  o.animate(a, n, "linear", function () {
                    S(r.resetValue, "reset", 0), F();
                  }));
        },
        w = function () {
          for (var e = "", i = "", n = f(), o = 0; o < n; o++)
            (i = ""),
              (s.settings.buildPager && t.isFunction(s.settings.buildPager)) ||
              s.settings.pagerCustom
                ? ((i = s.settings.buildPager(o)),
                  s.pagerEl.addClass("bx-custom-pager"))
                : ((i = o + 1), s.pagerEl.addClass("bx-default-pager")),
              (e +=
                '<div class="bx-pager-item"><a href="" data-slide-index="' +
                o +
                '" class="bx-pager-link">' +
                i +
                "</a></div>");
          s.pagerEl.html(e);
        },
        b = function () {
          s.settings.pagerCustom
            ? (s.pagerEl = t(s.settings.pagerCustom))
            : ((s.pagerEl = t('<div class="bx-pager" />')),
              s.settings.pagerSelector
                ? t(s.settings.pagerSelector).html(s.pagerEl)
                : s.controls.el.addClass("bx-has-pager").append(s.pagerEl),
              w()),
            s.pagerEl.on("click touchend", "a", I);
        },
        C = function () {
          (s.controls.next = t(
            '<a class="bx-next" href="">' + s.settings.nextText + "</a>"
          )),
            (s.controls.prev = t(
              '<a class="bx-prev" href="">' + s.settings.prevText + "</a>"
            )),
            s.controls.next.on("click touchend", P),
            s.controls.prev.on("click touchend", E),
            s.settings.nextSelector &&
              t(s.settings.nextSelector).append(s.controls.next),
            s.settings.prevSelector &&
              t(s.settings.prevSelector).append(s.controls.prev),
            s.settings.nextSelector ||
              s.settings.prevSelector ||
              ((s.controls.directionEl = t(
                '<div class="bx-controls-direction" />'
              )),
              s.controls.directionEl
                .append(s.controls.prev)
                .append(s.controls.next),
              s.controls.el
                .addClass("bx-has-controls-direction")
                .append(s.controls.directionEl));
        },
        T = function () {
          (s.controls.start = t(
            '<div class="bx-controls-auto-item"><a class="bx-start" href="">' +
              s.settings.startText +
              "</a></div>"
          )),
            (s.controls.stop = t(
              '<div class="bx-controls-auto-item"><a class="bx-stop" href="">' +
                s.settings.stopText +
                "</a></div>"
            )),
            (s.controls.autoEl = t('<div class="bx-controls-auto" />')),
            s.controls.autoEl.on("click", ".bx-start", M),
            s.controls.autoEl.on("click", ".bx-stop", y),
            s.settings.autoControlsCombine
              ? s.controls.autoEl.append(s.controls.start)
              : s.controls.autoEl
                  .append(s.controls.start)
                  .append(s.controls.stop),
            s.settings.autoControlsSelector
              ? t(s.settings.autoControlsSelector).html(s.controls.autoEl)
              : s.controls.el
                  .addClass("bx-has-controls-auto")
                  .append(s.controls.autoEl),
            D(s.settings.autoStart ? "stop" : "start");
        },
        k = function () {
          s.children.each(function (e) {
            var i = t(this).find("img:first").attr("title");
            void 0 !== i &&
              ("" + i).length &&
              t(this).append(
                '<div class="bx-caption"><span>' + i + "</span></div>"
              );
          });
        },
        P = function (t) {
          t.preventDefault(),
            s.controls.el.hasClass("disabled") ||
              (s.settings.auto && s.settings.stopAutoOnClick && o.stopAuto(),
              o.goToNextSlide());
        },
        E = function (t) {
          t.preventDefault(),
            s.controls.el.hasClass("disabled") ||
              (s.settings.auto && s.settings.stopAutoOnClick && o.stopAuto(),
              o.goToPrevSlide());
        },
        M = function (t) {
          o.startAuto(), t.preventDefault();
        },
        y = function (t) {
          o.stopAuto(), t.preventDefault();
        },
        I = function (e) {
          var i, n;
          e.preventDefault(),
            s.controls.el.hasClass("disabled") ||
              (s.settings.auto && s.settings.stopAutoOnClick && o.stopAuto(),
              (i = t(e.currentTarget)),
              void 0 !== i.attr("data-slide-index") &&
                (n = parseInt(i.attr("data-slide-index"))) !== s.active.index &&
                o.goToSlide(n));
        },
        z = function (e) {
          var i = s.children.length;
          if ("short" === s.settings.pagerType)
            return (
              s.settings.maxSlides > 1 &&
                (i = Math.ceil(s.children.length / s.settings.maxSlides)),
              void s.pagerEl.html(e + 1 + s.settings.pagerShortSeparator + i)
            );
          s.pagerEl.find("a").removeClass("active"),
            s.pagerEl.each(function (i, n) {
              t(n).find("a").eq(e).addClass("active");
            });
        },
        A = function () {
          if (s.settings.infiniteLoop) {
            var t = "";
            0 === s.active.index
              ? (t = s.children.eq(0).position())
              : s.active.index === f() - 1 && s.carousel
              ? (t = s.children.eq((f() - 1) * x()).position())
              : s.active.index === s.children.length - 1 &&
                (t = s.children.eq(s.children.length - 1).position()),
              t &&
                ("horizontal" === s.settings.mode
                  ? S(-t.left, "reset", 0)
                  : "vertical" === s.settings.mode && S(-t.top, "reset", 0));
          }
          (s.working = !1),
            s.settings.onSlideAfter.call(
              o,
              s.children.eq(s.active.index),
              s.oldIndex,
              s.active.index
            );
        },
        D = function (t) {
          s.settings.autoControlsCombine
            ? s.controls.autoEl.html(s.controls[t])
            : (s.controls.autoEl.find("a").removeClass("active"),
              s.controls.autoEl
                .find("a:not(.bx-" + t + ")")
                .addClass("active"));
        },
        q = function () {
          1 === f()
            ? (s.controls.prev.addClass("disabled"),
              s.controls.next.addClass("disabled"))
            : !s.settings.infiniteLoop &&
              s.settings.hideControlOnEnd &&
              (0 === s.active.index
                ? (s.controls.prev.addClass("disabled"),
                  s.controls.next.removeClass("disabled"))
                : s.active.index === f() - 1
                ? (s.controls.next.addClass("disabled"),
                  s.controls.prev.removeClass("disabled"))
                : (s.controls.prev.removeClass("disabled"),
                  s.controls.next.removeClass("disabled")));
        },
        H = function () {
          o.startAuto();
        },
        W = function () {
          o.stopAuto();
        },
        L = function () {
          s.settings.autoDelay > 0
            ? setTimeout(o.startAuto, s.settings.autoDelay)
            : (o.startAuto(), t(window).focus(H).blur(W)),
            s.settings.autoHover &&
              o.hover(
                function () {
                  s.interval && (o.stopAuto(!0), (s.autoPaused = !0));
                },
                function () {
                  s.autoPaused && (o.startAuto(!0), (s.autoPaused = null));
                }
              );
        },
        O = function () {
          var e,
            i,
            n,
            r,
            a,
            l,
            d,
            c,
            g = 0;
          "next" === s.settings.autoDirection
            ? o.append(s.children.clone().addClass("bx-clone"))
            : (o.prepend(s.children.clone().addClass("bx-clone")),
              (e = s.children.first().position()),
              (g = "horizontal" === s.settings.mode ? -e.left : -e.top)),
            S(g, "reset", 0),
            (s.settings.pager = !1),
            (s.settings.controls = !1),
            (s.settings.autoControls = !1),
            s.settings.tickerHover &&
              (s.usingCSS
                ? ((r = "horizontal" === s.settings.mode ? 4 : 5),
                  s.viewport.hover(
                    function () {
                      (i = o.css("-" + s.cssPrefix + "-transform")),
                        (n = parseFloat(i.split(",")[r])),
                        S(n, "reset", 0);
                    },
                    function () {
                      (c = 0),
                        s.children.each(function (e) {
                          c +=
                            "horizontal" === s.settings.mode
                              ? t(this).outerWidth(!0)
                              : t(this).outerHeight(!0);
                        }),
                        (a = s.settings.speed / c),
                        (l = "horizontal" === s.settings.mode ? "left" : "top"),
                        (d = a * (c - Math.abs(parseInt(n)))),
                        F(d);
                    }
                  ))
                : s.viewport.hover(
                    function () {
                      o.stop();
                    },
                    function () {
                      (c = 0),
                        s.children.each(function (e) {
                          c +=
                            "horizontal" === s.settings.mode
                              ? t(this).outerWidth(!0)
                              : t(this).outerHeight(!0);
                        }),
                        (a = s.settings.speed / c),
                        (l = "horizontal" === s.settings.mode ? "left" : "top"),
                        (d = a * (c - Math.abs(parseInt(o.css(l))))),
                        F(d);
                    }
                  )),
            F();
        },
        F = function (t) {
          var e,
            i,
            n,
            r = t || s.settings.speed,
            a = { left: 0, top: 0 },
            l = { left: 0, top: 0 };
          "next" === s.settings.autoDirection
            ? (a = o.find(".bx-clone").first().position())
            : (l = s.children.first().position()),
            (e = "horizontal" === s.settings.mode ? -a.left : -a.top),
            (i = "horizontal" === s.settings.mode ? -l.left : -l.top),
            (n = { resetValue: i }),
            S(e, "ticker", r, n);
        },
        N = function (e) {
          var i = t(window),
            n = { top: i.scrollTop(), left: i.scrollLeft() },
            s = e.offset();
          return (
            (n.right = n.left + i.width()),
            (n.bottom = n.top + i.height()),
            (s.right = s.left + e.outerWidth()),
            (s.bottom = s.top + e.outerHeight()),
            !(
              n.right < s.left ||
              n.left > s.right ||
              n.bottom < s.top ||
              n.top > s.bottom
            )
          );
        },
        B = function (t) {
          var e = document.activeElement.tagName.toLowerCase();
          if (null == new RegExp(e, ["i"]).exec("input|textarea") && N(o)) {
            if (39 === t.keyCode) return P(t), !1;
            if (37 === t.keyCode) return E(t), !1;
          }
        },
        X = function () {
          (s.touch = { start: { x: 0, y: 0 }, end: { x: 0, y: 0 } }),
            s.viewport.on("touchstart MSPointerDown pointerdown", Y),
            s.viewport.on("click", ".bxslider a", function (t) {
              s.viewport.hasClass("click-disabled") &&
                (t.preventDefault(), s.viewport.removeClass("click-disabled"));
            });
        },
        Y = function (t) {
          if ("touchstart" === t.type || 0 === t.button)
            if (
              (t.preventDefault(),
              s.controls.el.addClass("disabled"),
              s.working)
            )
              s.controls.el.removeClass("disabled");
            else {
              s.touch.originalPos = o.position();
              var e = t.originalEvent,
                i = void 0 !== e.changedTouches ? e.changedTouches : [e],
                n = "function" == typeof PointerEvent;
              if (n && void 0 === e.pointerId) return;
              (s.touch.start.x = i[0].pageX),
                (s.touch.start.y = i[0].pageY),
                s.viewport.get(0).setPointerCapture &&
                  ((s.pointerId = e.pointerId),
                  s.viewport.get(0).setPointerCapture(s.pointerId)),
                (s.originalClickTarget = e.originalTarget || e.target),
                (s.originalClickButton = e.button),
                (s.originalClickButtons = e.buttons),
                (s.originalEventType = e.type),
                (s.hasMove = !1),
                s.viewport.on("touchmove MSPointerMove pointermove", R),
                s.viewport.on("touchend MSPointerUp pointerup", Z),
                s.viewport.on("MSPointerCancel pointercancel", V);
            }
        },
        V = function (t) {
          t.preventDefault(),
            S(s.touch.originalPos.left, "reset", 0),
            s.controls.el.removeClass("disabled"),
            s.viewport.off("MSPointerCancel pointercancel", V),
            s.viewport.off("touchmove MSPointerMove pointermove", R),
            s.viewport.off("touchend MSPointerUp pointerup", Z),
            s.viewport.get(0).releasePointerCapture &&
              s.viewport.get(0).releasePointerCapture(s.pointerId);
        },
        R = function (t) {
          var e = t.originalEvent,
            i = void 0 !== e.changedTouches ? e.changedTouches : [e],
            n = Math.abs(i[0].pageX - s.touch.start.x),
            o = Math.abs(i[0].pageY - s.touch.start.y),
            r = 0,
            a = 0;
          (s.hasMove = !0),
            3 * n > o && s.settings.preventDefaultSwipeX
              ? t.preventDefault()
              : 3 * o > n &&
                s.settings.preventDefaultSwipeY &&
                t.preventDefault(),
            "touchmove" !== t.type && t.preventDefault(),
            "fade" !== s.settings.mode &&
              s.settings.oneToOneTouch &&
              ("horizontal" === s.settings.mode
                ? ((a = i[0].pageX - s.touch.start.x),
                  (r = s.touch.originalPos.left + a))
                : ((a = i[0].pageY - s.touch.start.y),
                  (r = s.touch.originalPos.top + a)),
              S(r, "reset", 0));
        },
        Z = function (e) {
          e.preventDefault(),
            s.viewport.off("touchmove MSPointerMove pointermove", R),
            s.controls.el.removeClass("disabled");
          var i = e.originalEvent,
            n = void 0 !== i.changedTouches ? i.changedTouches : [i],
            r = 0,
            a = 0;
          (s.touch.end.x = n[0].pageX),
            (s.touch.end.y = n[0].pageY),
            "fade" === s.settings.mode
              ? (a = Math.abs(s.touch.start.x - s.touch.end.x)) >=
                  s.settings.swipeThreshold &&
                (s.touch.start.x > s.touch.end.x
                  ? o.goToNextSlide()
                  : o.goToPrevSlide(),
                o.stopAuto())
              : ("horizontal" === s.settings.mode
                  ? ((a = s.touch.end.x - s.touch.start.x),
                    (r = s.touch.originalPos.left))
                  : ((a = s.touch.end.y - s.touch.start.y),
                    (r = s.touch.originalPos.top)),
                !s.settings.infiniteLoop &&
                ((0 === s.active.index && a > 0) || (s.active.last && a < 0))
                  ? S(r, "reset", 200)
                  : Math.abs(a) >= s.settings.swipeThreshold
                  ? (a < 0 ? o.goToNextSlide() : o.goToPrevSlide(),
                    o.stopAuto())
                  : S(r, "reset", 200)),
            s.viewport.off("touchend MSPointerUp pointerup", Z),
            s.viewport.get(0).releasePointerCapture &&
              s.viewport.get(0).releasePointerCapture(s.pointerId),
            !1 !== s.hasMove ||
              (0 !== s.originalClickButton &&
                "touchstart" !== s.originalEventType) ||
              t(s.originalClickTarget).trigger({
                type: "click",
                button: s.originalClickButton,
                buttons: s.originalClickButtons,
              });
        },
        U = function (e) {
          if (s.initialized)
            if (s.working) window.setTimeout(U, 10);
            else {
              var i = t(window).width(),
                n = t(window).height();
              (r === i && a === n) ||
                ((r = i),
                (a = n),
                o.redrawSlider(),
                s.settings.onSliderResize.call(o, s.active.index));
            }
        },
        j = function (t) {
          var e = v();
          s.settings.ariaHidden &&
            !s.settings.ticker &&
            (s.children.attr("aria-hidden", "true"),
            s.children.slice(t, t + e).attr("aria-hidden", "false"));
        },
        Q = function (t) {
          return t < 0
            ? s.settings.infiniteLoop
              ? f() - 1
              : s.active.index
            : t >= f()
            ? s.settings.infiniteLoop
              ? 0
              : s.active.index
            : t;
        };
      return (
        (o.goToSlide = function (e, i) {
          var n,
            r,
            a,
            l,
            d = !0,
            c = 0,
            g = { left: 0, top: 0 },
            u = null;
          if (
            ((s.oldIndex = s.active.index),
            (s.active.index = Q(e)),
            !s.working && s.active.index !== s.oldIndex)
          ) {
            if (
              ((s.working = !0),
              void 0 !==
                (d = s.settings.onSlideBefore.call(
                  o,
                  s.children.eq(s.active.index),
                  s.oldIndex,
                  s.active.index
                )) && !d)
            )
              return (s.active.index = s.oldIndex), void (s.working = !1);
            "next" === i
              ? s.settings.onSlideNext.call(
                  o,
                  s.children.eq(s.active.index),
                  s.oldIndex,
                  s.active.index
                ) || (d = !1)
              : "prev" === i &&
                (s.settings.onSlidePrev.call(
                  o,
                  s.children.eq(s.active.index),
                  s.oldIndex,
                  s.active.index
                ) ||
                  (d = !1)),
              (s.active.last = s.active.index >= f() - 1),
              (s.settings.pager || s.settings.pagerCustom) && z(s.active.index),
              s.settings.controls && q(),
              "fade" === s.settings.mode
                ? (s.settings.adaptiveHeight &&
                    s.viewport.height() !== p() &&
                    s.viewport.animate(
                      { height: p() },
                      s.settings.adaptiveHeightSpeed
                    ),
                  s.children
                    .filter(":visible")
                    .fadeOut(s.settings.speed)
                    .css({ zIndex: 0 }),
                  s.children
                    .eq(s.active.index)
                    .css("zIndex", s.settings.slideZIndex + 1)
                    .fadeIn(s.settings.speed, function () {
                      t(this).css("zIndex", s.settings.slideZIndex), A();
                    }))
                : (s.settings.adaptiveHeight &&
                    s.viewport.height() !== p() &&
                    s.viewport.animate(
                      { height: p() },
                      s.settings.adaptiveHeightSpeed
                    ),
                  !s.settings.infiniteLoop && s.carousel && s.active.last
                    ? "horizontal" === s.settings.mode
                      ? ((u = s.children.eq(s.children.length - 1)),
                        (g = u.position()),
                        (c = s.viewport.width() - u.outerWidth()))
                      : ((n = s.children.length - s.settings.minSlides),
                        (g = s.children.eq(n).position()))
                    : s.carousel && s.active.last && "prev" === i
                    ? ((r =
                        1 === s.settings.moveSlides
                          ? s.settings.maxSlides - x()
                          : (f() - 1) * x() -
                            (s.children.length - s.settings.maxSlides)),
                      (u = o.children(".bx-clone").eq(r)),
                      (g = u.position()))
                    : "next" === i && 0 === s.active.index
                    ? ((g = o
                        .find("> .bx-clone")
                        .eq(s.settings.maxSlides)
                        .position()),
                      (s.active.last = !1))
                    : e >= 0 &&
                      ((l = e * parseInt(x())),
                      (g = s.children.eq(l).position())),
                  void 0 !== g &&
                    ((a =
                      "horizontal" === s.settings.mode
                        ? -(g.left - c)
                        : -g.top),
                    S(a, "slide", s.settings.speed)),
                  (s.working = !1)),
              s.settings.ariaHidden && j(s.active.index * x());
          }
        }),
        (o.goToNextSlide = function () {
          if ((s.settings.infiniteLoop || !s.active.last) && !0 !== s.working) {
            var t = parseInt(s.active.index) + 1;
            o.goToSlide(t, "next");
          }
        }),
        (o.goToPrevSlide = function () {
          if (
            (s.settings.infiniteLoop || 0 !== s.active.index) &&
            !0 !== s.working
          ) {
            var t = parseInt(s.active.index) - 1;
            o.goToSlide(t, "prev");
          }
        }),
        (o.startAuto = function (t) {
          s.interval ||
            ((s.interval = setInterval(function () {
              "next" === s.settings.autoDirection
                ? o.goToNextSlide()
                : o.goToPrevSlide();
            }, s.settings.pause)),
            s.settings.onAutoChange.call(o, !0),
            s.settings.autoControls && !0 !== t && D("stop"));
        }),
        (o.stopAuto = function (t) {
          s.autoPaused && (s.autoPaused = !1),
            s.interval &&
              (clearInterval(s.interval),
              (s.interval = null),
              s.settings.onAutoChange.call(o, !1),
              s.settings.autoControls && !0 !== t && D("start"));
        }),
        (o.getCurrentSlide = function () {
          return s.active.index;
        }),
        (o.getCurrentSlideElement = function () {
          return s.children.eq(s.active.index);
        }),
        (o.getSlideElement = function (t) {
          return s.children.eq(t);
        }),
        (o.getSlideCount = function () {
          return s.children.length;
        }),
        (o.isWorking = function () {
          return s.working;
        }),
        (o.redrawSlider = function () {
          s.children.add(o.find(".bx-clone")).outerWidth(h()),
            s.viewport.css("height", p()),
            s.settings.ticker || m(),
            s.active.last && (s.active.index = f() - 1),
            s.active.index >= f() && (s.active.last = !0),
            s.settings.pager &&
              !s.settings.pagerCustom &&
              (w(), z(s.active.index)),
            s.settings.ariaHidden && j(s.active.index * x());
        }),
        (o.destroySlider = function () {
          s.initialized &&
            ((s.initialized = !1),
            t(".bx-clone", this).remove(),
            s.children.each(function () {
              void 0 !== t(this).data("origStyle")
                ? t(this).attr("style", t(this).data("origStyle"))
                : t(this).removeAttr("style");
            }),
            void 0 !== t(this).data("origStyle")
              ? this.attr("style", t(this).data("origStyle"))
              : t(this).removeAttr("style"),
            t(this).unwrap().unwrap(),
            s.controls.el && s.controls.el.remove(),
            s.controls.next && s.controls.next.remove(),
            s.controls.prev && s.controls.prev.remove(),
            s.pagerEl &&
              s.settings.controls &&
              !s.settings.pagerCustom &&
              s.pagerEl.remove(),
            t(".bx-caption", this).remove(),
            s.controls.autoEl && s.controls.autoEl.remove(),
            clearInterval(s.interval),
            s.settings.responsive && t(window).off("resize", U),
            s.settings.keyboardEnabled && t(document).off("keydown", B),
            t(this).removeData("bxSlider"),
            t(window).off("blur", W).off("focus", H));
        }),
        (o.reloadSlider = function (e) {
          void 0 !== e && (n = e),
            o.destroySlider(),
            l(),
            t(o).data("bxSlider", this);
        }),
        l(),
        t(o).data("bxSlider", this),
        this
      );
    }
  };
})(jQuery);
